module.exports = __webpack_public_path__ + "static/media/BMODE_40_30.44ffbe0b.jpg";